<div class="menu-mobile-container">
  <!-- Skeleton loader when no currentUser -->
  <div *ngIf="!(currentUser$ | async)" class="w-full mobile-menu-skeleton">
    <!-- User profile skeleton -->
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center gap-3">
        <div class="w-8 h-8 rounded-full bg-gray-200 animate-pulse"></div>
        <div class="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
      </div>
      <div class="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
    </div>

    <div class="h-px w-full bg-gray-200 my-4" data-section-separator></div>

    <!-- Nav items skeleton -->
    <div class="space-y-4 p-4">
      <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="flex items-center justify-between gap-3">
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 rounded bg-gray-200 animate-pulse"></div>
          <div class="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
        </div>
        <div class="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
      </div>
    </div>

    <div class="h-px w-full bg-gray-200 my-4" data-section-separator></div>

    <!-- Bottom items skeleton -->
    <div class="p-4 space-y-4">
      <div *ngFor="let i of [1, 2]" class="flex items-center gap-3">
        <div class="w-8 h-8 rounded bg-gray-200 animate-pulse"></div>
        <div class="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
      </div>

      <div class="h-12 w-full rounded-lg bg-gray-200 animate-pulse mt-4"></div>
    </div>
  </div>

  <!-- menu container -->
  <nav class="nav__main" *ngIf="currentUser$ | async as currentUser">
    <a
      *ngIf="currentUser$ | async as currentUser"
      [routerLink]="['/settings/profile']"
      style="width: 100%"
      #rla="routerLinkActive"
      routerLinkActive="active-link"
      fxLayout
      fxLayoutAlign="start center"
      class="nav-parent">
      <div class="nav-item-container">
        <div class="relative">
          <img
            class="nav__user-profile"
            fxFlex="0 0 32px"
            [src]="currentUser.team.owner_picture"
            [alt]="currentUser.team.owner_first_name"
            onerror="this.src='/assets/images/profile-default.png'" />
          <span *ngIf="!isTeamOwner" class="um__switcher-name-badge">
            {{ currentUser.first_name.charAt(0) }}{{ currentUser.last_name.charAt(0) }}
          </span>
        </div>
        <span fxFlex [@.disabled]="!animEnabled" class="nav__name ellipsis">
          {{ currentUser.first_name }} {{ currentUser.last_name }}
        </span>
        <sbnb-icon *ngIf="!isTeamOwner" [hidden]="!expanded" icon="users-simple" class="pr-2 text-grape"></sbnb-icon>
      </div>
    </a>

    <ng-container *ngIf="!isTeamOwner">
      <strong class="um__switcher-header">
        {{ teams.length === 1 ? ('CORE.PRODUCT_NAME' | transloco) + ' account' : 'Switch account' }}
      </strong>
      <div
        *ngFor="let team of teams"
        class="um__switcher-team"
        [class.um__unselecable]="teams.length === 1"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="8px"
        (click)="changeActiveTeam(team.team_id)">
        <img
          class="um__switcher-profile"
          [src]="team.picture"
          onerror="this.src='/assets/images/profile-default.png'" />
        <span [class.um__active]="team.active" fxFlex class="ellipsis">{{ team.name }}</span>
      </div>
    </ng-container>

    <div class="h-px w-full bg-gray-200 my-4" data-section-separator></div>
    <div *ngFor="let item of navItems">
      <ng-container *ngIf="item.position === 'top'">
        <sbnb-menu-item [item]="item" [badgeCounts]="badgeCounts"></sbnb-menu-item>
        <div class="h-px w-full bg-gray-200 my-4" data-section-separator *ngIf="item.separator"></div>
      </ng-container>
    </div>

    <div class="" *ngIf="perms$.permissions | async as perms">
      <nav class="nav__secondary">
        <ng-container *ngFor="let item of navItems">
          <ng-container *ngIf="item.position === 'bottom'">
            <sbnb-menu-item [item]="item" [badgeCounts]="badgeCounts"></sbnb-menu-item>
            <div class="h-px w-full bg-gray-200 my-4" data-section-separator *ngIf="item.separator"></div>
          </ng-container>
        </ng-container>

        <ng-container *ngFor="let sumItem of matMenuItems">
          <sbnb-menu-item
            *ngIf="perms?.is_admin || perms?.is_team_owner"
            [item]="sumItem"
            [badgeCounts]="badgeCounts"></sbnb-menu-item>
        </ng-container>

        <div class="h-px w-full bg-gray-200 my-4" data-section-separator></div>

        <sbnb-menu-item
          *ngFor="let sumItem of matMenuHelperItems"
          [item]="sumItem"
          [badgeCounts]="badgeCounts"></sbnb-menu-item>

        <button (click)="logout()" id="nav-user-logout" class="w-full h-12 px-6 rounded-lg">Logout</button>
      </nav>
    </div>
  </nav>
</div>
